import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import ItemBorder from '@v4/components/common/ItemBorder'
import clsx from 'clsx'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{ classes, itemKey, itemNumber, buttonLink, buttonAction, buttonTextKey, buttonText, buttonTextEditable },
		{ handleButtonTextChange, handleButtonClick, handleClick },
	] = useItem(props)

	return (
		<Box className={clsx(classes.root, 'cta14-item')} onClick={handleClick}>
			<ItemBorder itemKey={itemKey} group="items">
				<ActionButton
					data-number={itemNumber}
					editable={buttonTextEditable}
					className={classes.button}
					action={buttonAction}
					href={buttonLink}
					onClick={handleButtonClick}
					onChange={handleButtonTextChange}
					key={buttonTextKey}
					displayEmpty
				>
					{buttonText || ''}
				</ActionButton>
			</ItemBorder>
		</Box>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
}

export default memo(Item)
